import { Autocomplete } from '@react-google-maps/api';
import React from 'react';
import styles from './styles.module.scss';

interface ISearchLocationProps {
  handlePlaceChanged: () => void;
  setAutocomplete: React.Dispatch<
    React.SetStateAction<google.maps.places.Autocomplete | undefined>
  >;
}

export const SearchLocation = ({ setAutocomplete, handlePlaceChanged }: ISearchLocationProps) => {
  return (
    <Autocomplete
      onLoad={(autocompleteInstance) => setAutocomplete(autocompleteInstance)}
      onPlaceChanged={handlePlaceChanged}>
      <div className={styles.searchLocation}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-location">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
        </svg>
        <input type="text" placeholder="Type in your city or ZIP code" />
      </div>
    </Autocomplete>
  );
};
